export default "__VITE_ASSET__BZL_eJzc__"